import { OrderTableData } from '@teinor/erp/prices/quote/totals'
import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'
import { useCallback } from 'react'
import { ModalPaymentMethodTPVProps } from '..'
import { CustomSelectWithSearchBar } from '../../../../../../../../../forms/CustomSelect'
import { BeforeSubmitHandler } from '../../../../../../../../../forms/TwinForm/types'
import { parseSelectedTableDataForRefund } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useMultiOrderRefundLogic/functions'
import BasePaymentMethodsTPV from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodsTPV'
import { HookBaseFuntionModalPaymentMethodTPVProps, HookComponentFuntionModalPaymentMethodTPVProps } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodsTPV/types'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../../../../utils/reducers/reduxDispatch'
import { parseSellTicketRefundSelectedTableForProcessing } from '../../../../functions'

const ModalPaymentMethodSellTicketRefund: React.FC<ModalPaymentMethodTPVProps> = ({ url, completeData, translations, ...rest }) => {
    const { t } = useTwinTranslation()
    const tableData = parseSelectedTableDataForRefund(completeData) as OrderTableData
   
    return (
        <BasePaymentMethodsTPV url={url} completeData={completeData} tableData={tableData as any} hookComponentsFuntion={usePaymentMethodTypesComponentSellTicketRefundLogic} hookBaseFuntion={useModalPaymentMethodSellTicketRefundLogic} translations={{ textButton: translations?.textButton || t('confirmRefund', 'Confirmar devolución'), textTotal: translations?.textTotal || t('totalRefund', 'Total devolución') }} isRefund={true} {...{...rest}} />
    )
}

const useModalPaymentMethodSellTicketRefundLogic = ({ completeData, setOpenModal, checkAllOk, myTotalPayments, allRowData, isReservedRefund }: HookBaseFuntionModalPaymentMethodTPVProps) => {
    const { t } = useTwinTranslation()
    const notSelectedProducts = t('notSelectedProducts', 'No has seleccionado ningún producto.')

    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((vals, form) => {
        const itsOk = checkAllOk(vals, form)
        if (!itsOk) {
            return false
        }
        if (!allRowData?.canRegularize) {
            const myPaymentMethodInfo: TwinDictionary[] = []
            for (const key in vals.paymentMethodInfo) {
                const element = vals.paymentMethodInfo[key]
                element.quantity = parseFloat(String(element.quantity)) * -1
                myPaymentMethodInfo.push(element)
            }
            vals.paymentMethodInfo = myPaymentMethodInfo
        }
        vals.SellTicketId = completeData?.header?.id
        vals.CashRegisterId = completeData.cashRegister?.id
        if (!isReservedRefund) {
            const selectedProducts = parseSellTicketRefundSelectedTableForProcessing(completeData)
            if (selectedProducts.forSend.products?.length) {
                vals.selectedProducts = selectedProducts.forSend.products
            } else {
                changeErrorMessage(notSelectedProducts)
                return false
            }
        }
        setOpenModal({ type: 'edit', allRowData: { values: vals, Customer: completeData?.header?.Customer, CurrencyId: completeData?.header?.CurrencyId, myTotalPayments, WarehouseId: allRowData?.WarehouseId, WorkingCenterId: completeData?.cashRegister?.WorkingCenterId} })
        return false
    }, [checkAllOk, completeData, notSelectedProducts, setOpenModal, myTotalPayments, allRowData, isReservedRefund])

    return { handleBeforeSubmit }
}

const usePaymentMethodTypesComponentSellTicketRefundLogic = ({ element, dictPaymentBanks, handleChangeField, rowIndex }: HookComponentFuntionModalPaymentMethodTPVProps) => {
    const { t } = useTwinTranslation()
    const dictComponentLabels: Record<PaymentRelatedTypesKeys, TwinDictionary> = {
        0: { label: '', extraProps: {} },
        1: {
            component: CustomSelectWithSearchBar,
            label: t('targetAccount', 'Cuenta de destino'),
            extraProps: { items: dictPaymentBanks?.customerBanks?.items || {}, className: 'flex flex-auto custom_select_hide_label h-28 overflow-visible', fieldName: 'fullname', value: element?.new_extra_payment_data?.id || element?.new_extra_payment_data?.value || element?.payment_data || dictPaymentBanks?.customerBanks?.defaultId, onChange: (value: any) => handleChangeField(rowIndex, 'payment_data', value) }
        },
        2: {
            component: CustomSelectWithSearchBar,
            label: t('targetAccount', 'Cuenta de destino'),
            extraProps: { items: dictPaymentBanks?.customerBanks?.items || {}, className: 'flex flex-auto  custom_select_hide_label h-28  overflow-visible', fieldName: 'fullname', value: element?.new_extra_payment_data?.id || element?.new_extra_payment_data?.value || element?.payment_data || dictPaymentBanks?.customerBanks?.defaultId, onChange: (value: any) => handleChangeField(rowIndex, 'payment_data', value) }
        },
        3: { label: '', extraProps: {} },
        4: { label: '', extraProps: {} },
        5: { label: '', extraProps: {} },
        6: {
            component: CustomSelectWithSearchBar,
            label: t('targetDataphone', 'Datáfono de destino'),
            extraProps: { items: dictPaymentBanks?.workingCenterShift4Devices?.items || {}, className: 'flex flex-auto  custom_select_hide_label h-28  overflow-visible', value: element?.new_extra_payment_data?.id || element?.new_extra_payment_data?.value || element?.payment_data || dictPaymentBanks?.workingCenterShift4Devices?.defaultId, onChange: (value: any) => handleChangeField(rowIndex, 'payment_data', value) }
        },
        7: { label: '', extraProps: { } },
    }
    return { dictComponentLabels }
}

export default ModalPaymentMethodSellTicketRefund